import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

import { getDataFromSessionStorage, setDataToSessionStorage } from 'src/utils/sessionStorage'

export interface IUseUtmQueryParams {
  utmMedium?: string
  utmSource?: string
  utmCampaign?: string
}

const UTM_SESSION_STORAGE_KEY = 'utmQuery'

const getUtmQuerySessionStorage = (): IUseUtmQueryParams => {
  return getDataFromSessionStorage<IUseUtmQueryParams>(UTM_SESSION_STORAGE_KEY) ?? {}
}

const useUtmQueryParams = (): IUseUtmQueryParams => {
  const params = useSearchParams()
  const [localQueryParams, setLocalQueryParams] = useState<null | IUseUtmQueryParams>(getUtmQuerySessionStorage())

  useEffect(() => {
    const utmMedium = params.get('utm_medium')
    const utmCampaign = params.get('utm_campaign')
    const utmSource = params.get('utm_source')

    if (utmMedium || utmCampaign || utmSource) {
      const utm = { utmMedium, utmSource, utmCampaign }
      setDataToSessionStorage(UTM_SESSION_STORAGE_KEY, utm)
      setLocalQueryParams(utm)
    }
  }, [params])

  return localQueryParams
}

export default useUtmQueryParams
